export default "__VITE_ASSET__BhGT2Dxj__"